export default __webpack_public_path__ + "static/media/storm-bg.9d439164.png";